import { Vue, Component } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { TENANT_SETTINGS_KEYS_MAPPING } from '@/utils/constants';
import FormLoader from '../form-loader/form-loader';
import { tenantSettingsAPI } from '@/providers/apis/tenant-settings/tenant-settings';

@Component({
    name: 'localization',
    components: {
        'material-icons': GoogleMaterialIcon,
        'form-loader': FormLoader,
    },
})

export default class Localization extends Vue {


    private tenantSettings: any = [];

    private tenantkeyDefinition: any = TENANT_SETTINGS_KEYS_MAPPING;

    private selectedConfig: any = null;

    private activeComponent: string = 'tx-loader';

    private created() {
        this.$store.dispatch('tenantStore/fetchTenantSettings').then(() => {
           this.tenantSettings = this.$store.state.tenantStore.tenantSettings;
           this.onSelectSettings(this.tenantkeyDefinition.tx_sub_classifier_prefs, 'tx_sub_classifier_prefs');
        });
    }


    // -------------------------------------------------------------------------------
    // Actions

    private onSelectSettings(setting: any, value: string) {
        setting.tenantKey = value;
        this.activeComponent = setting.key;
        const existingKey = this.tenantSettings.find((item: any) => item.key === value) || {};
        setting.tenantConfig = existingKey;
        this.selectedConfig = setting;
    }

    private onChangeConfig(config: any) {
        const payload = {
            tenant_key: this.selectedConfig.tenantKey,
            value: (typeof config === 'object' ? JSON.stringify(config) : config),
        };
        // this.updateConfig(payload);
    }



    // --------------------------------------------------------------------------------
    // Methods

    private updateConfig(config: any) {
        tenantSettingsAPI.updateTenantSettings(config).then(() => {
            this.$store.dispatch('tenantStore/fetchTenantSettings').then(() => {
                this.tenantSettings = this.$store.state.tenantStore.tenantSettings;
             });
        });
    }

    private diabledItem(item: any) {
        if (item.key === 'nav-class-setup' || item.key === 'cm-completion-score') {
            const framworkData = this.tenantSettings.find((setting: any) => setting.key === 'tx_fw_prefs');
            return framworkData ? false : true;
        }
    }


}
